//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSysDirectory as _getSysDirectory } from '@data/user';
import { getLoginLogList as _getLoginLogList } from '@data/other';
export default {
  name: 'system-log',
  created: function created() {},
  mounted: function mounted() {
    this.getSysDirectory();
  },
  data: function data() {
    return {
      queryClass: {
        startTime: '',
        // 开始时间
        endTime: '',
        // 结束时间
        opeType: '',
        // 操作功能
        pageNo: 1,
        pageSize: 15
      },
      // 登录日志过滤查询条件
      directoryData: {
        DC0035: [{
          code: 'DC0035',
          id: 65900450608,
          itemName: '学生',
          name: '用户类型',
          subList: [],
          type: 1,
          value: '5'
        }, {
          code: 'DC0035',
          id: 65900450609,
          itemName: '教师',
          name: '用户类型',
          subList: [],
          type: 1,
          value: '7'
        }, {
          code: 'DC0035',
          id: 65900450610,
          itemName: '家长',
          name: '用户类型',
          subList: [],
          type: 1,
          value: '6'
        }],
        DC0036: [{
          code: 'DC0036',
          id: 65900450611,
          itemName: '全部',
          name: '操作功能',
          subList: [],
          type: 1
        }, {
          code: 'DC0036',
          id: 65900450612,
          itemName: '登录',
          name: '操作功能',
          subList: [],
          type: 1,
          value: '0'
        }, {
          code: 'DC0036',
          id: 65900450613,
          itemName: '退出',
          name: '操作功能',
          subList: [],
          type: 1,
          value: '1'
        }]
      },
      loginLogDao: {
        rowCount: 0,
        list: []
      }
    };
  },
  methods: {
    getSysDirectory: function getSysDirectory() {
      var self = this; // DC0029 --学历；DC0008--民族

      _getSysDirectory({
        codes: 'DC0035,DC0036'
      }).then(function (res) {
        res = {
          DC0035: [{
            code: 'DC0035',
            id: 65900450608,
            itemName: '学生',
            name: '用户类型',
            subList: [],
            type: 1,
            value: '5'
          }, {
            code: 'DC0035',
            id: 65900450609,
            itemName: '教师',
            name: '用户类型',
            subList: [],
            type: 1,
            value: '7'
          }, {
            code: 'DC0035',
            id: 65900450610,
            itemName: '家长',
            name: '用户类型',
            subList: [],
            type: 1,
            value: '6'
          }],
          DC0036: [{
            code: 'DC0036',
            id: 65900450611,
            itemName: '全部',
            name: '操作功能',
            subList: [],
            type: 1
          }, {
            code: 'DC0036',
            id: 65900450612,
            itemName: '登录',
            name: '操作功能',
            subList: [],
            type: 1,
            value: '0'
          }, {
            code: 'DC0036',
            id: 65900450613,
            itemName: '退出',
            name: '操作功能',
            subList: [],
            type: 1,
            value: '1'
          }]
        };
        self.directoryData = res;
        self.getLoginLogList(1);
      }).catch(function () {});
    },
    getLoginLogList: function getLoginLogList(type) {
      var self = this;

      if (type === 1) {
        self.queryClass.pageNo = 1; // 如果是查询按钮触发，回到第一页
      } // 日期初始化


      self.queryClass.startTime = self.queryClass.startTime || ''; // 开始时间

      self.queryClass.endTime = self.queryClass.endTime || ''; // 结束时间

      var params = self.queryClass;

      _getLoginLogList(params).then(function (res) {
        self.loginLogDao = res;
      }).catch(function () {
        self.loginLogDao = {
          rowCount: 0,
          list: []
        };
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryClass.pageNo = val;
      this.getLoginLogList();
    }
  }
};